import script from "./EditTopic.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTopic.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__